import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { AiTranscriptionDeliveryModesFetchedAction } from '@Application/Ai/AiTranscriptionDeliveryModes/Actions/aiTranscriptionDeliveryModesFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AiTranscriptionDeliveryModesStore = {
	aiTranscriptionDeliveryModes: readonly LabeledValueView[] | null;
};

const initialState: AiTranscriptionDeliveryModesStore = {
	aiTranscriptionDeliveryModes: null,
};

type Actions = AiTranscriptionDeliveryModesFetchedAction | UserRevokedAction;

const whenAiTranscriptionDeliveryModesFetched = (
	store: AiTranscriptionDeliveryModesStore,
	action: AiTranscriptionDeliveryModesFetchedAction,
): AiTranscriptionDeliveryModesStore => ({
	...store,
	aiTranscriptionDeliveryModes: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AiTranscriptionDeliveryModesStore => initialState;

export default registerStore<'aiTranscriptionDeliveryModesStore', Actions>(
	'aiTranscriptionDeliveryModesStore',
	createSliceReducer({
		AI_TRANSCRIPTION_DELIVERY_MODES_FETCHED: whenAiTranscriptionDeliveryModesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
